import { motion } from 'framer-motion';

function ProjectCard({ project, index }) {
  return (
    <motion.article
      className="project-card"
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.55, delay: index * 0.08 }}
    >
      <div className="project-image">
        <img
          src={project.project_image.url}
          alt={project.project_image.alt}
          loading="lazy"
        />
      </div>
      <div className="project-copy">
        <p className="project-category">{project.project_category}</p>
        <h3>{project.title}</h3>
        <p>{project.project_description}</p>
      </div>
    </motion.article>
  );
}

export default ProjectCard;